import MuiIconButton from "Components/MuiIconButton/MuiIconButton";
import React, { useState } from "react";
import * as Icons from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";

export default function TicketTextBox({
  side = "user",
  data,
  text,
  changeText,
  onChange,
  selectedFile,
  onDeleteFile,
  onDone,
}) {
  const { t } = useTranslation();
  const [fileUploader, setFileUploader] = useState("");
  const onUploadClick = (e) => {
    e.preventDefault();
    fileUploader.click();
  };
  const onChangeText = (e) => {
    changeText(e);
    const tear = document.getElementById("description");
    if (e.target.value !== "") {
      tear.style.height = `${e.target.scrollHeight}px`;
    } else {
      tear.style.height = "40px";
    }
  };
  return (
    <div className="newTicketBox">
      <input
        ref={(e) => setFileUploader(e)}
        type="file"
        onChange={onChange}
        style={{ display: "none" }}
      />
      <textarea
        type="text"
        id="description"
        value={text}
        onChange={onChangeText}
        placeholder={t("saveNewMessage")}
      />
      <div className="newTicketBox-buttons">
        {!selectedFile ? (
          <MuiIconButton
            className="warning-fill"
            title={t("upload")}
            icon={<Icons.CloudUpload size={19} />}
            onClick={onUploadClick}
          />
        ) : (
          <MuiIconButton
            className="danger-fill"
            title={t("delete")}
            icon={<Icons.XLg size={14} />}
            onClick={onDeleteFile}
          />
        )}
        <MuiIconButton
          className="warning-fill"
          title={t("sendMSG")}
          icon={<Icons.Send size={19} />}
          onClick={onDone}
        />
      </div>
    </div>
  );
}
